import { useState } from "react";
import { UserRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { STATES } from "@/lib/constants";

export function ProfileForm() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name || "", state: user.state || "QLD", suburb: user.suburb || "", postcode: user.postcode || "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault(); setErr("");
    if (f.postcode && !/^\d{4}$/.test(f.postcode)) return setErr("Postcode must be 4 digits");
    setBusy(true);
    try {
      const { data } = await api.patch("/auth/me/profile", { ...f, suburb: f.suburb || null, postcode: f.postcode || null });
      setUser(data);
      toast.success("Profile updated");
    } catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  return (
    <form data-testid="profile-form" onSubmit={save} className="mb-6 max-w-xl space-y-4 rounded-2xl bg-[#173742] p-6">
      <p className="flex items-center gap-2 font-semibold"><UserRound className="h-5 w-5 text-[#d4f253]" />My details</p>
      <div>
        <label className="mb-1.5 block text-xs font-semibold text-slate-300">Name shown to others</label>
        <input data-testid="profile-name-input" required minLength={2} maxLength={60} className="field" value={f.name} onChange={up("name")} />
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        <div>
          <label className="mb-1.5 block text-xs font-semibold text-slate-300">State</label>
          <select data-testid="profile-state-select" className="field" value={f.state} onChange={up("state")}>
            {STATES.filter((s) => s.id !== "ALL").map((s) => <option key={s.id} value={s.id}>{s.id}</option>)}
          </select>
        </div>
        <div>
          <label className="mb-1.5 block text-xs font-semibold text-slate-300">Suburb</label>
          <input data-testid="profile-suburb-input" maxLength={60} className="field" value={f.suburb} onChange={up("suburb")} placeholder="e.g. Southport" />
        </div>
        <div>
          <label className="mb-1.5 block text-xs font-semibold text-slate-300">Postcode</label>
          <input data-testid="profile-postcode-input" inputMode="numeric" maxLength={4} className="field" value={f.postcode} onChange={(e) => setF({ ...f, postcode: e.target.value.replace(/\D/g, "") })} placeholder="4215" />
        </div>
      </div>
      {err && <p data-testid="profile-error" className="rounded-lg bg-red-500/15 px-3 py-2 text-sm text-red-300">{err}</p>}
      <button data-testid="profile-save-btn" disabled={busy} className="btn-lime px-6 py-3 text-sm">{busy ? "Saving…" : "Save details"}</button>
      <p className="text-xs text-slate-400">To fix the suburb or postcode on an item you've already listed, use Edit on that listing.</p>
    </form>
  );
}
